import { WorkspaceUserWithRole } from '@/models/workspace';
import { ColumnDef } from '@tanstack/react-table';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type UserEmailCellProps = {
  user: WorkspaceUserWithRole;
};

const UserEmailCell: FC<UserEmailCellProps> = ({ user }) => {
  return (
    <div className='flex items-center gap-3'>
      <div className='flex flex-col'>
        <span className='text-sm font-medium text-primary-900'>{user.user.email}</span>
        {(user.user.firstName || user.user.lastName) && (
          <span className='text-xs text-tertiary-600'>{`${user.user.firstName || ''} ${user.user.lastName || ''}`.trim()}</span>
        )}
      </div>
    </div>
  );
};

const UserEmailHeader: FC = () => {
  const { t } = useTranslation();
  return <>{t('COMMON:user')}</>;
};

export const userEmailColumn: ColumnDef<WorkspaceUserWithRole> = {
  accessorKey: 'user.email',
  header: UserEmailHeader,
  cell: ({ row }) => <UserEmailCell user={row.original} />,
  enableSorting: true,
  sortingFn: (rowA, rowB) => {
    const emailA = rowA.original.user.email.toLowerCase();
    const emailB = rowB.original.user.email.toLowerCase();
    return emailA.localeCompare(emailB);
  },
};
